import { api } from "@/api";
import { toolConfigStore, ToolStatusConfig } from "@/store/toolConfig";
import useSWR from "swr";

export function useToolConfig() {
  useSWR(
    "tool_status_config",
    async () => {
      const res = await api.configs.getConfig({
        keys: ["tool_status_config"],
      });
      const configItem = res.data.values?.find(
        (v) => v.key === "tool_status_config"
      );
      if (configItem?.value) {
        try {
          return JSON.parse(configItem.value) as ToolStatusConfig;
        } catch (e) {
          console.error("Failed to parse tool_status_config", e);
        }
      }
      return null;
    },
    {
      onSuccess: (data) => {
        if (data) {
          toolConfigStore.setToolConfig(data);
        }
      },
      // Long polling interval as requested (e.g., 60 seconds)
      refreshInterval: 60 * 1000,
      revalidateOnFocus: false,
    }
  );
}
